import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

import { type ProjectSubmitterResponse } from 'generated/models/ProjectSubmitterResponse';

/**
 * Utility for merging class names with Tailwind CSS
 * This is used by shadcn/ui components for className merging
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatRoleName(roleName: string) {
  return roleName
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export const getSubmittersList = (
  submitters: ProjectSubmitterResponse[] | undefined,
) => {
  if (!submitters) return '--';
  return submitters.map((submitter) => submitter.name).join(', ');
};

export const getTailwindConfig = () => {
  let tailwindConfig;
  try {
    // Try main app path first (from shared/utils to root)
    tailwindConfig = require('../../tailwind.config');
    console.debug('Using parent tailwind config', tailwindConfig);
  } catch {
    try {
      // Try Microsoft integration path (from shared/utils to integrations/microsoft)
      tailwindConfig = require('../../integrations/microsoft/tailwind.config');
      console.debug('Using Microsoft tailwind config', tailwindConfig);
    } catch {
      // Fallback - this shouldn't happen, but just in case
      console.warn('Could not load tailwind config, using empty config');
      tailwindConfig = { theme: { colors: {} } };
    }
  }
  return tailwindConfig;
};
